import { UserModel } from '.';

export class LoginInfoModel {
    doctor: UserModel;
    loginSession: {
        mToken: string
        userLocalType: "ADMIN" | "PHARMACIST"
        mUserId?: string
        mTtl?: string
        mCreated?: string
    }

    constructor(loginInfo: any) {
        this.doctor = loginInfo.doctor || new UserModel({})
        this.loginSession = loginInfo.loginSession || {}
    }
}